import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const unlockGroup = api(async function unlockGroup({ projectId, groupId }) {
    return mutate(
        gql`
            mutation UnlockGroup($projectId: String!, $groupId: String!) {
                unlockGroup(projectId: $projectId, groupId: $groupId) {
                    success
                    error
                }
            }
        `,
        { projectId, groupId },
        { returns: "unlockGroup" }
    )
})
